import React, {PropsWithChildren} from "react";

const FormButtons = (props: PropsWithChildren) => (
    <div className="form-buttons">
        {props.children}
    </div>
);

export default FormButtons;